import { CookieKeys, clearCookie, getCookie, setCookie } from '../hooks/useCookie';
import { LocalStorageKeys, triggerStorageEvent } from '../services/localStorage';
import queryClient from '../services/marketplace/queryClient';
import { RequireAtLeastOne } from './types/typeHelpers';

const ONE_DAY = 24 * 60 * 60 * 1000;
export const JWT_TYPE_KEY = 'https://api.leaseend.com/userType';
export const EMAIL_KEY = 'https://api.leaseend.com/email';
export const ANONYMOUS_USER_TYPE = 'anonymous';

export type JWTToken = {
  [JWT_TYPE_KEY]: string;
  [EMAIL_KEY]: string;
  sub: string;
};

export type ResetAuthOpts = RequireAtLeastOne<{
  removeGuid?: boolean;
  removeAccessToken?: boolean;
  resetGuid?: boolean;
}>;

const resetGuidLifetime = () => {
  const guid = getCookie(CookieKeys.GUID_KEY);
  if (guid) {
    setCookie(CookieKeys.GUID_KEY, guid, ONE_DAY);
  }
};

export const clearOneClickLoginAttempts = () => {
  localStorage.removeItem(LocalStorageKeys.ONE_CLICK_LOGIN_EMAIL);
  triggerStorageEvent(LocalStorageKeys.ONE_CLICK_LOGIN_EMAIL);
};

export const resetAuth = ({ removeGuid, resetGuid, removeAccessToken }: ResetAuthOpts) => {
  if (resetGuid) {
    resetGuidLifetime();
  }

  if (removeGuid) {
    clearCookie(CookieKeys.GUID_KEY);
  }

  if (removeAccessToken) {
    clearCookie(CookieKeys.ACCESS_TOKEN);
  }

  clearOneClickLoginAttempts();
  queryClient.clear();
};

export const isAnonymousUser = (decodedToken: JWTToken | null) => {
  return decodedToken?.[JWT_TYPE_KEY] === ANONYMOUS_USER_TYPE;
};

export const getEmailFromJWT = (decodedToken: JWTToken | null) => {
  return decodedToken?.[EMAIL_KEY];
};
